<div class="dialog-container">
    <h2 mat-dialog-title>Neuen Artikel anlegen</h2>
    <mat-dialog-content>
        <form [formGroup]="createArticleForm">
            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Artikelnummer</mat-label>
                <input
                    matInput
                    formControlName="articleNumber" />
                @if (
                    createArticleForm
                        .get('articleNumber')
                        ?.hasError('required') &&
                    createArticleForm.get('articleNumber')?.touched
                ) {
                    <mat-error>Artikelnummer wird benötigt</mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Beschreibung</mat-label>
                <input
                    matInput
                    formControlName="description" />
                @if (
                    createArticleForm
                        .get('description')
                        ?.hasError('required') &&
                    createArticleForm.get('description')?.touched
                ) {
                    <mat-error>Beschreibung wird benötigt</mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Menge</mat-label>
                <input
                    matInput
                    type="number"
                    min="1"
                    formControlName="quantity" />
                @if (
                    createArticleForm.get('quantity')?.hasError('required') &&
                    createArticleForm.get('quantity')?.touched
                ) {
                    <mat-error>Menge wird benötigt</mat-error>
                }
                @if (
                    createArticleForm.get('quantity')?.hasError('min') &&
                    createArticleForm.get('quantity')?.touched
                ) {
                    <mat-error>Menge muss mindestens 1 sein</mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Index</mat-label>
                <input
                    matInput
                    type="number"
                    min="0"
                    formControlName="index" />
                @if (
                    createArticleForm.get('index')?.hasError('required') &&
                    createArticleForm.get('index')?.touched
                ) {
                    <mat-error>Index wird benötigt</mat-error>
                }
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Artikel-Bestellnummer (optional)</mat-label>
                <input
                    matInput
                    formControlName="articleOrderNumber" />
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Kundenartikel-Nr. (optional)</mat-label>
                <input
                    matInput
                    formControlName="customerArticleNumber" />
            </mat-form-field>

            <mat-form-field
                appearance="outline"
                class="field-full">
                <mat-label>Containertyp</mat-label>
                <input
                    matInput
                    formControlName="containerType" />
                @if (
                    createArticleForm
                        .get('containerType')
                        ?.hasError('required') &&
                    createArticleForm.get('containerType')?.touched
                ) {
                    <mat-error>Containertyp wird benötigt</mat-error>
                }
            </mat-form-field>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button
            mat-stroked-button
            (click)="onCancel()">
            Abbrechen
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="onSubmit()">
            Artikel erstellen
        </button>
    </mat-dialog-actions>
</div>
